import React, { useState } from "react";
import { Modal, Box, Typography, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { addComplexService, attachServicesToComplex } from "../../../components/http";
import TextInput from "../../../components/inputs/TextInput";
import DurationInput from "../../../components/inputs/DurationInput";
import ButtonsGroup from "../../../components/PopUps/ButtonsGroup";
import MultiServiceSelect from "../../../components/Search/MultiServiceSelect";
import styles from "./ComplexServiceAddPopup.module.scss";

const ComplexServiceAddPopup = ({ open, onClose, onComplexServiceAdded }) => {
  const { t } = useTranslation("");
  const [complexService, setComplexService] = useState({
    name: "",
    comment: "",
    price: 0,
    duration: { days: 0, hours: 0, minutes: 0 },
  });
  const [selectedServices, setSelectedServices] = useState([]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setComplexService({
      ...complexService,
      [name]: name === "price" ? parseFloat(value) : value,
    });
  };

  const handleDurationChange = (duration) => {
    setComplexService({ ...complexService, duration });
  };

  const formatDurationToISO = () => {
    const { days, hours, minutes } = complexService.duration;
    let isoString = "P";

    if (days > 0) isoString += `${days}D`;
    if (hours > 0 || minutes > 0) {
      isoString += "T";
      if (hours > 0) isoString += `${hours}H`;
      if (minutes > 0) isoString += `${minutes}M`;
    }

    return isoString === "P" ? "" : isoString;
  };

  const handleSave = async () => {
    const formattedDuration = formatDurationToISO();
    if (!complexService.name || complexService.price <= 0 || !formattedDuration) {
      alert(t("complexService.Add.errorEmptyFields"));
      return;
    }

    try {
      const newComplexService = await addComplexService({
        name: complexService.name,
        comment: complexService.comment,
        price: complexService.price,
      });

      if (selectedServices.length > 0 && newComplexService.complex_service_id) {
        await attachServicesToComplex({
          complex_service_id: newComplexService.complex_service_id,
          services: selectedServices.map((service) => service.id), 
        });
      }

      alert(t("complexService.Add.successMessage"));
      onComplexServiceAdded();
      onClose(); 
    } catch (error) {
      console.error("Error adding complex service:", error);
      alert(t("complexService.Add.errorMessage"));
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose} className={styles.modalContainer}>
        <div className={styles.modalContent}>
        <h2 className={styles.title}>{t("complexService.Add.title")}</h2>


        <div className={styles.inputsContainer}>

          <TextInput
            label={t("complexService.Add.name")}
            name="name"
            value={complexService.name}
            onChange={handleInputChange}
            fullWidth
          />
          <TextInput
            label={t("complexService.Add.comment")}
            name="comment"
            value={complexService.comment}
            onChange={handleInputChange}
            fullWidth
          />
          <TextInput
            label={t("complexService.Add.price")}
            name="price"
            type="number"
            value={complexService.price}
            onChange={handleInputChange}
            fullWidth
          />
          <MultiServiceSelect
            onServicesChange={(selected) => setSelectedServices(selected)}
            placeholder={t("complexService.Add.services")}
          />
            <ButtonsGroup
              onSave={handleSave}
              onCancel={onClose}
              saveText={t("complexService.Add.save")}
              cancelText={t("complexService.Add.cancel")}
            />
          </div>
          </div>
    </Modal>
  );
};

export default ComplexServiceAddPopup;
